import ActionTypes from 'store/actionTypes/admin/actions';

export type List = 'mentorship' | 'mentorFormation';

type SetPage = (
  list: List,
  page: number,
) => { type: ActionTypes; value: number };
export const setPage: SetPage = (list, page) => {
  switch (list) {
    case 'mentorship':
      return {
        type: ActionTypes.MENTORSHIP_SET_PAGE,
        value: page,
      };
    case 'mentorFormation':
      return {
        type: ActionTypes.FORMATION_SET_PAGE,
        value: page,
      };
    default:
      return {
        type: ActionTypes.MENTORSHIP_SET_PAGE,
        value: 0,
      };
  }
};

type SetSearch = (
  list: List,
  search: string,
) => { type: ActionTypes; value: string };
export const setSearch: SetSearch = (list, search) => {
  switch (list) {
    case 'mentorship':
      return {
        type: ActionTypes.MENTORSHIP_SET_SEARCH,
        value: search,
      };
    case 'mentorFormation':
      return {
        type: ActionTypes.FORMATION_SET_SEARCH,
        value: search,
      };
    default:
      return {
        type: ActionTypes.MENTORSHIP_SET_SEARCH,
        value: '',
      };
  }
};

type SetTake = (
  list: List,
  take: number,
) => { type: ActionTypes; value: number };
export const setTake: SetTake = (list, take) => {
  switch (list) {
    case 'mentorship':
      return {
        type: ActionTypes.MENTORSHIP_SET_TAKE,
        value: take,
      };
    case 'mentorFormation':
      return {
        type: ActionTypes.FORMATION_SET_TAKE,
        value: take,
      };
    default:
      return {
        type: ActionTypes.MENTORSHIP_SET_TAKE,
        value: 30,
      };
  }
};
